import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'breakableHtml',
  standalone: true,
  pure: true
})
export class BreakableHtmlPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string | null | undefined | any): SafeHtml {
        if (!value) return '';

        // Remplacer toutes les variantes d’espaces insécables par un espace normal
        let cleaned = value
            .replace(/&nbsp;/gi, ' ')
            .replace(/&#160;/gi, ' ')
            .replace(/\u00A0/g, ' ')
            // optionnel : éviter des blocs d’espaces consécutifs
            .replace(/\s{2,}/g, ' ');

        return this.sanitizer.bypassSecurityTrustHtml(cleaned);
    }

}
